<app-loader [isLoader]="loading"></app-loader>

<section class="page-gutter">

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <h1>Content Pool</h1>
      <p>Manage and monitor your content pools</p>
    </div>
    <div class="header-right">
      <div class="search-box">
        <img [src]="searchIcon" class="search-icon" alt="search" />
        <input type="text" placeholder="Search by Content Name"
          [(ngModel)]="filter.search" (input)="onSearch($event)" />
      </div>
      @if(userPermissions.includes(6)){
        <button class="btn-create" (click)="navigateToCreateContentPool()">
          <img [src]="plusIcon" alt="plus" />
          Create New
        </button>
      }
    </div>
  </div>

  <!-- Table Card -->
  <div class="table-card">
    @if(contentPoolList.length > 0){
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th class="col-name">
                <span class="sortable" (click)="sorting('name')">
                  Content Name
                  <span class="sort-icons">
                    <i class="arr up" [class.active]="sortingKey==='name' && sortingValue==='ASC'"></i>
                    <i class="arr down" [class.active]="sortingKey==='name' && sortingValue==='DESC'"></i>
                  </span>
                </span>
              </th>
              <th class="col-desc">Description</th>
              <th class="col-status">Status</th>
              <th class="col-num">
                <span class="sortable" (click)="sorting('totalRequests')">
                  Total Requests
                  <span class="sort-icons">
                    <i class="arr up" [class.active]="sortingKey==='totalRequests' && sortingValue==='ASC'"></i>
                    <i class="arr down" [class.active]="sortingKey==='totalRequests' && sortingValue==='DESC'"></i>
                  </span>
                </span>
              </th>
              <th class="col-num">
                <span class="sortable" (click)="sorting('totalSuccessRequests')">
                  Success Requests
                  <span class="sort-icons">
                    <i class="arr up" [class.active]="sortingKey==='totalSuccessRequests' && sortingValue==='ASC'"></i>
                    <i class="arr down" [class.active]="sortingKey==='totalSuccessRequests' && sortingValue==='DESC'"></i>
                  </span>
                </span>
              </th>
              <th class="col-num">
                <span class="sortable" (click)="sorting('brandSafe')">
                  Brand Safe
                  <span class="sort-icons">
                    <i class="arr up" [class.active]="sortingKey==='brandSafe' && sortingValue==='ASC'"></i>
                    <i class="arr down" [class.active]="sortingKey==='brandSafe' && sortingValue==='DESC'"></i>
                  </span>
                </span>
              </th>
              <th class="col-num">
                <span class="sortable" (click)="sorting('mappedAssests')">
                  Mapped Assets
                  <span class="sort-icons">
                    <i class="arr up" [class.active]="sortingKey==='mappedAssests' && sortingValue==='ASC'"></i>
                    <i class="arr down" [class.active]="sortingKey==='mappedAssests' && sortingValue==='DESC'"></i>
                  </span>
                </span>
              </th>
              <th class="col-created">Created By</th>
              <th class="col-date">
                <span class="sortable" (click)="sorting('createdAt')">
                  Created At
                  <span class="sort-icons">
                    <i class="arr up" [class.active]="sortingKey==='createdAt' && sortingValue==='ASC'"></i>
                    <i class="arr down" [class.active]="sortingKey==='createdAt' && sortingValue==='DESC'"></i>
                  </span>
                </span>
              </th>
              <th class="col-action">Action</th>
            </tr>
          </thead>
          <tbody>
            @for(pool of contentPoolList; track $index){
              <tr>
                <td class="col-name">
                  <span class="pool-name" (click)="handleContentPoolClick($event, pool.id)" [title]="pool.name || '-'">
                    {{ pool.name || '-' }}
                  </span>
                </td>
                <td class="col-desc">
                  <span class="desc-text" [title]="pool.description || ''">{{ pool.description || '-' }}</span>
                </td>
                <td class="col-status">
                  <span class="status-chip" [ngClass]="getStatusChipClass(pool.status)">
                    {{ pool.status | upperCase }}
                  </span>
                </td>
                <td class="col-num">
                  <span class="num-val">{{ (pool.total_requests | numberSuffix) || '-' }}</span>
                </td>
                <td class="col-num">
                  <span class="num-val success">{{ (pool.total_success_requests | numberSuffix) || '-' }}</span>
                </td>
                <td class="col-num">
                  <span class="num-val">{{ (pool.brand_safe | numberSuffix) || '-' }}</span>
                </td>
                <td class="col-num">
                  <span class="num-val">{{ (pool.mapped_assets | numberSuffix) || '-' }}</span>
                </td>
                <td class="col-created">
                  <span class="created-by">{{ pool.created_by_name || '-' }}</span>
                </td>
                <td class="col-date">
                  <span class="date-val">{{ pool.created_at | date: 'dd MMM yyyy' }}</span>
                </td>
                <td class="col-action">
                  <div class="action-dropdown">
                    <button class="action-btn"
                      (click)="toggleDropdown($index)"
                      [disabled]="!userPermissions.includes(7) && !userPermissions.includes(8) && !userPermissions.includes(9)">
                      <img src="assets/img/verticle.svg" alt="more" />
                    </button>
                    <div class="dropdown-menu" [class.show]="activeDropdownIndex === $index">
                      <div class="dropdown-item" (click)="navigateToEditContentPool(pool.id)"
                        [class.disabled]="!userPermissions.includes(7)">
                        <img src="assets/img/edit.svg" alt="edit" />
                        <span>Edit Content Pool</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="pagination-wrap">
        <app-custom-pagination [filter]="filter" [total]="totalCount" (savePage)="fetchUserDataByPage($event)"></app-custom-pagination>
      </div>
    }

    @if(contentPoolList.length === 0 && loading === false){
      <app-no-data [noData]="noData" (createNewClick)="navigateToCreateContentPool()"></app-no-data>
    }
  </div>

</section>
